import I18n from 'I18n';
import { SOURCE_FILTER_VALUES } from '../constants/constants';
export const getVisibleAttachmentRows = (filteredAttachmentRows, pagingChoices) => {
  const newStartingIndex = (pagingChoices.currentPage - 1) * pagingChoices.currentPageSize;
  return filteredAttachmentRows.slice(newStartingIndex, newStartingIndex + pagingChoices.currentPageSize);
};
export const getNumberOfPages = (numRows, currentPageSize) => Math.ceil(numRows / currentPageSize);
export const formatDate = millis => {
  return I18n.moment.userTz(millis).format('MMM DD, YYYY h:mm A z');
};
export const getFormattedSource = source => {
  switch (source) {
    case SOURCE_FILTER_VALUES.TASK:
      return I18n.text('viewAll.sources.task');
    case SOURCE_FILTER_VALUES.MEETING:
      return I18n.text('viewAll.sources.meeting');
    case SOURCE_FILTER_VALUES.NOTE:
      return I18n.text('viewAll.sources.note');
    case SOURCE_FILTER_VALUES.CALL:
      return I18n.text('viewAll.sources.call');
    case SOURCE_FILTER_VALUES.CONVERSATION_SESSION:
      return I18n.text('viewAll.sources.conversation');
    case SOURCE_FILTER_VALUES.EMAIL:
      return I18n.text('viewAll.sources.email');
    case SOURCE_FILTER_VALUES.DIRECT_UPLOAD:
      return I18n.text('viewAll.sources.manualUpload');
    case SOURCE_FILTER_VALUES.SMS:
      return I18n.text('viewAll.sources.sms');
    case SOURCE_FILTER_VALUES.WHATS_APP:
      return I18n.text('viewAll.sources.whatsApp');
    case SOURCE_FILTER_VALUES.LINKEDIN_MESSAGE:
      return I18n.text('viewAll.sources.linkedinMessage');
    default:
      return '';
  }
};
export const isRenameAttachmentConflictError = error => error && error.networkError && error.networkError.status === 409;